/**
 * What the signed-out screens need to know about this server.
 *
 * Whether "Forgot password?" works and whether signup needs an invite code are
 * decided by the server's environment, not by this bundle, so they are asked
 * for rather than assumed. While the answer is unknown, both features are
 * treated as unavailable: showing a "Forgot password?" link that then says
 * "not set up on this server" is worse than showing it a moment later.
 */
import { useQuery } from '@tanstack/react-query';
import type { AuthConfig } from '@medtrack/shared';

import { api } from '@/lib/api';

export const authConfigKey = ['auth', 'config'] as const;

export function useAuthConfig() {
  return useQuery({
    queryKey: authConfigKey,
    queryFn: () => api.get<AuthConfig>('/auth/config'),
    // Changes only when the operator edits .env and restarts.
    staleTime: 5 * 60_000,
  });
}
